module.exports = "./img/dae322c750642f79936ce419a50460ac.jpg";